import { capitalize, Grid, Box } from '@mui/material';
import { AppSelect, SelectOptions } from 'components/core/Select/AppSelect';
import dayjs from 'dayjs';
import { generateMonthOptions } from 'helpers/dayMonthHelpers';
import { useMemo } from 'react';
import styled from 'styled-components';

interface Props {
  currYear: number;
  currMonth: number;
  lastDateOfRates: string;
  setCurrMonth: (num: number) => void;
  setCurrYear: (num: number) => void;
}

export const StyledBox = styled(Box)`
padding: ${props => props.theme.spacing(2)};
background-color: ${props => props.theme.palette.grey[50]};
`;

export const CheckoutDateRangePickerYearMonthSelect = ({
  currYear,
  currMonth,
  lastDateOfRates,
  setCurrMonth,
  setCurrYear,
}: Props) => {
  const years: SelectOptions = useMemo(() => {
    const thisYear = new Date().getFullYear();
    const lastYearOfRates = dayjs(lastDateOfRates).year();

    const years = [];
    for (let i = thisYear; i <= lastYearOfRates; i++) {
      years.push({
        value: i,
        label: capitalize(i.toString()),
      });
    }

    return years;
  }, [lastDateOfRates]);

  const monthOptions: SelectOptions = useMemo(() => {
    const lastYearOfRates = dayjs(lastDateOfRates).year();
    const lastMonthOfRates = dayjs(lastDateOfRates).month() + 1;
    const firstMonthOfRates = dayjs().month() + 1;
    const firstYearOfRates = dayjs().year();

    const opts = generateMonthOptions();
    const selectOpts = opts.map(option => {
      const disabledBefore = currYear === firstYearOfRates && option.value < firstMonthOfRates;
      const disabledAfter = currYear === lastYearOfRates && option.value > lastMonthOfRates;

      return {
        value: option.value,
        label: option.label,
        disabled: disabledBefore || disabledAfter,
      };
    });
    return selectOpts;
  }, [currYear, lastDateOfRates]);

  const onChangeYear = (e: any) => {
    const newYear = e.target.value;

    const lastYearOfRates = dayjs(lastDateOfRates).year();
    const lastMonthOfRates = dayjs(lastDateOfRates).month() + 1;
    const firstMonthOfRates = dayjs().month() + 1;
    const firstYearOfRates = dayjs().year();

    if (newYear === lastYearOfRates && currMonth > lastMonthOfRates) {
      setCurrMonth(lastMonthOfRates);
    }
    if (newYear === firstYearOfRates && currMonth < firstMonthOfRates) {
      setCurrMonth(firstMonthOfRates);
    }
    if (newYear === firstYearOfRates && firstYearOfRates === lastYearOfRates && currMonth > lastMonthOfRates) {
      setCurrMonth(lastMonthOfRates);
    }

    setCurrYear(newYear);
  };

  const onChangeMonth = (e: any) => {
    setCurrMonth(e.target.value);
  };

  return (
    <StyledBox>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <AppSelect label={'Year'} value={currYear} options={years} onChange={onChangeYear} />
        </Grid>
        <Grid item xs={6}>
          <AppSelect label="Month" value={currMonth} options={monthOptions} onChange={onChangeMonth} />
        </Grid>
      </Grid>
    </StyledBox>
  );
};
